export default commomImport => [{
  path: `category-list`,
  name: 'CategoryList',
  meta: {
    title: 'store.menuSetting'
  },
  //  全部订单
  component: commomImport('product-manager/category-list')
}];
